import Typography from "../../../../../../../../common/Typography";
import BuyNowButton from "../../../../BuyNowButton";

const MembershipExpired = ({
  currMemb,
  activity,
  currencyView,
  handleRenew = () => {},
}) => (
  <div className="membership-expired-card">
    <Typography size="heading-lg" weight="medium">
      Membership Expired
    </Typography>
    <div className="custom-row">
      <Typography size="heading-sm">{activity.date_time}</Typography>
      <Typography weight="medium">
        {activity.membership_type === "reward_bundle" ? "Rewards Bundle" : "Wallet"}
      </Typography>
    </div>
    <BuyNowButton
      isShowRenewTxt
      handleClick={handleRenew}
      secondaryTextSize="text-sm"
      primaryTextSize="heading-md"
      data={{
        text_color: "#0E1B1B",
        theme_color: "#ffffff",
        expiry: currMemb?.settings?.membership_expiry,
        price: `${currencyView}${currMemb?.subscription_details?.price}`,
      }}
    />
  </div>
);

export default MembershipExpired;
